import React, { Suspense, lazy } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import content from './data/content.json';

// Optimization: Lazy load below-the-fold components
const Problem = lazy(() => import('./components/Problem'));
const HomeWorth = lazy(() => import('./components/HomeWorth'));
const Bio = lazy(() => import('./components/Bio'));
const Stats = lazy(() => import('./components/Stats'));
const Services = lazy(() => import('./components/Services'));
const Process = lazy(() => import('./components/Process'));
const Listings = lazy(() => import('./components/Listings'));
const NewListingsForm = lazy(() => import('./components/NewListingsForm'));
const Testimonials = lazy(() => import('./components/Testimonials'));
const Consultation = lazy(() => import('./components/Consultation'));
const FinalCTA = lazy(() => import('./components/FinalCTA'));
const Footer = lazy(() => import('./components/Footer'));
const ContactWidget = lazy(() => import('./components/ContactWidget'));

function App() {
  React.useEffect(() => {
    // Dynamic SEO
    if (content.site) {
      document.title = content.site.seo?.metaTitle || content.site.title || 'Real Estate Agent';

      const metaDesc = document.querySelector('meta[name="description"]');
      if (metaDesc) {
        metaDesc.setAttribute('content', content.site.seo?.metaDescription || content.site.description || '');
      }
    }
  }, []);

  return (
    <div className="app">
      <Navbar data={content.nav} />
      <Hero data={content.hero} />

      <Suspense fallback={<div className="h-screen w-full bg-slate-50" />}>
        {/* Group 1: High Priority (Just below fold) */}
        <Problem data={content.problem} />
        <HomeWorth data={content.homeWorth} />
      </Suspense>

      <Suspense fallback={<div className="h-screen w-full bg-white" />}>
        {/* Group 2: Content Heavy */}
        <Bio data={content.bio} />
        <Stats data={content.bio.stats} />
        <Services data={content.services} />
        <Process data={content.process} />
      </Suspense>

      <Suspense fallback={<div className="h-screen w-full bg-slate-50" />}>
        {/* Group 3: Media Heavy */}
        <Listings data={content.listings} />
        <NewListingsForm data={content.newListingsForm} />
        <Testimonials data={content.testimonials} />
      </Suspense>

      <Suspense fallback={<div className="h-[600px] w-full bg-white" />}>
        {/* Group 4: Interaction/Scheduling */}
        <Consultation data={content.consultation} />
        <FinalCTA data={content.finalCTA} />
        <Footer data={content.footer} />
      </Suspense>

      {/* Widget loads last */}
      <Suspense fallback={null}>
        <ContactWidget />
      </Suspense>
    </div>
  );
}

export default App;
